import { HELMET } from '../fontFamilies';

const helmet = {
  sans: {
    regular: {
      fontFamily: HELMET,
      fontStyle: 'normal',
      fontWeight: 400,
    },
    regularItalic: {
      fontFamily: HELMET,
      fontStyle: 'italic',
      fontWeight: 400,
    },
    bold: {
      fontFamily: HELMET,
      fontStyle: 'normal',
      fontWeight: 700,
    },
    boldItalic: {
      fontFamily: HELMET,
      fontStyle: 'italic',
      fontWeight: 700,
    },
  },
};

export default helmet;
